import env from '../../../env'
import buildQuery from 'odata-query'
import api from '../../services/api.js'
import { getUser, getUserFactoryId } from '../../../index'
import { getUserAccessLevel } from '../../helpers/role.js'


export async function apiGETUser() {
    const FactoryId = getUserFactoryId()
    // const response = (await api.get(`user/odata?$select=email&$filter=systemRole/name%20eq%20%27Admin%20Fabrica%27 and factoryId eq ${FactoryId}`)).data;
    const queryParams = buildQuery({
        select: ['email'],
        // select: ['*'] get all
        orderBy: ['Email asc'],
        filter: {
            'systemRole/name': 'Admin Fabrica',
            FactoryId: parseInt(FactoryId),
            status: true
        }
    });
    const response = (await api.get(`user/odata${queryParams}`)).data
    //console.log('Respnse',response.value)
    return response.value
}

export const ModulePages = [
    
]


export const Ajuda = [
    { name: 'Ajuda', to: '/HelpIndex' },
]
export const MinhasAtividades = [
    { name: 'Meus Documentos (autor)', to: '/standard' },
    { name: 'Meus Treinamentos', to: '/user/training' },
    { name: 'Painel do Supervisor', to: '/painelsupervisor' },
    { name: 'Fluxos de Aprovação', to: '/approval' },
]

export const LPP = [
    { name: 'Lista de LPP', to: '/lpp' },
    { name: 'Cadastrar Nova LPP', to: '/lpp/new/0' },
]

export const DTP = [
    { name: 'Lista de DTPs', to: '/dtp' },
    { name: 'Cadastrar Nova DTP', to: '/dtp/new/0' },
]

export const IDCARD = [
    { name: 'Lista de ID Card', to: '/idcard/list' },
    { name: 'Cadastrar Novo ID Card', to: '/idcard/new/0' },
    { name: 'Relatório de ID Card', to: '/idcard/relatorio' },
    { name: 'Exportar ID Card para DMO', to: '/idcard/ExportDMO' },
]

export const MaterialTreinamento = [
    { name: 'Lista de Materiais de Treinamento', to: '/trainingmaterial/list' },
    { name: 'Cadastrar Novo Material de Treinamento', to: '/trainingmaterial/new/0' },
    { name: 'Minhas Turmas de Treinamento', to: (env.matriz_URL + 'MyClassroom')  },
    { name: 'Calendário de Treinamentos', to: (env.matriz_URL + 'calendar/training')  },
]

export const Funil = [
    { name: 'Lista de Funis', to: '/funnel/list' },
    { name: 'Cadastrar Novo Funil', to: '/funnel/new/0' },
    { name: 'Farol Funil', to: '/farol/0/0' },
]

export const BibliotecaTreinamentosExternos = [
    { name: "Lista de Documentos", to: "/externaldocumentlist"}
]
export const BibliotecaTreinamentosExternosAdmin = [
    { name: "Lista de Documentos", to: "/externaldocumentlist"},
    { name: "Cadastrar Treinamento - ILearn", to: "/externaltraining" },
    { name: "Cadastrar Documentos - DMS", to: "/externaldocumentqms" },
    { name: "Cadastrar Documentos - Pilar", to: "/ExternalDocumentPilarPage" }
]